import * as S from './styles';

function Footer() {
  return <S.Container>© 싱싱청과물</S.Container>;
}

export default Footer;
